import {HitModule} from '../../objects/ModuleHit';
import {MyUserCompany} from '../../objects/UserCompany';

export enum enumValues {
  email,
  password,
  confirmPassword,
  firstName,
  lastName,
  vatNumber,
  countryCode,
  designationLegal,
  street,
  houseNumber,
  boxNumber,
  postCode,
  city,
  billingEmail,
  phone,
  mobile,
  rightsAccepted,
  dateRequest,
  checkVatNumberBeforeAddAccount,
  userSystemLanguage,
  activity,
  referralCode,
}

export class Form {
  // USAGE = Used to add content in the object user that's passed on all pages
  static addContentInUserCompanyObject(
    myUser: MyUserCompany,
    propToModify: enumValues,
    data: string | null,
    booleanValue?: boolean,
    _listValue?: HitModule[],
    _intValue?: number,
  ) {
    if (
      data === '' ||
      data === null ||
      data === 'null' ||
      data === undefined ||
      data === 'undefined'
    ) {
      data = null;
    }
    switch (propToModify) {
      case enumValues.email:
        myUser.usernameEmail = data;
        break;
      case enumValues.password:
        myUser.password = data;
        break;
      case enumValues.confirmPassword:
        myUser.confirmPassword = data;
        break;
      case enumValues.firstName:
        myUser.firstName = data;
        break;
      case enumValues.lastName:
        myUser.lastName = data;
        break;
      case enumValues.vatNumber:
        myUser.vatNumber = data;
        break;
      case enumValues.countryCode:
        myUser.countryCode = data;
        break;
      case enumValues.designationLegal:
        myUser.designationLegal = data;
        break;
      case enumValues.street:
        myUser.street = data;
        break;
      case enumValues.houseNumber:
        myUser.houseNumber = data;
        break;
      case enumValues.boxNumber:
        myUser.boxNumber = data;
        break;
      case enumValues.postCode:
        myUser.postCode = data;
        break;
      case enumValues.city:
        myUser.city = data;
        break;
      case enumValues.billingEmail:
        myUser.billingEmail = data;
        break;
      case enumValues.phone:
        myUser.phone = data;
        break;
      case enumValues.mobile:
        myUser.mobile = data;
        break;
      case enumValues.rightsAccepted:
        myUser.rightsAccepted = booleanValue!;
        break;
      case enumValues.dateRequest:
        myUser.dateRequest = new Date();
        break;
      case enumValues.checkVatNumberBeforeAddAccount:
        myUser.checkVatNumberBeforeAddAccount = booleanValue!;
        break;
      case enumValues.userSystemLanguage:
        myUser.userSystemLanguage = data;
        break;
      case enumValues.activity:
        myUser.activity = data;
        break;
      case enumValues.referralCode:
        myUser.referralCode = data;
        break;
    }
  }
}

// ***************************************************************
//           Functions called on all pages of the form
// ***************************************************************
